<template>
	<div v-cloak>
		<!-- 手机端 -->
		<div v-show="!fullWidth" style="overflow: auto; background-color: rgba(237, 235, 246, 1)">
			<!-- <div
    :style="{ height: screenHeight }"
    style="overflow: auto; background-color: rgba(237, 235, 246, 1)"
  > -->

			<img src="../assets/hade.png" alt style="width: 100%" />
			<!-- 内容 -->
			<div style="padding: 0 1.2rem">
				<!-- 一级选择 -->
				<div class="flex-between">
					<div class="imgTitle" @click="handleLevel1Select(1)" :class="bgColor == 1 ? 'bgColor' : ''"><img src="../assets/clothing.png" alt /></div>
					<div class="imgTitle" :class="bgColor == 2 ? 'bgColor' : ''"><img src="../assets/food.png" alt @click="handleLevel1Select(2)" /></div>
					<div class="imgTitle" :class="bgColor == 3 ? 'bgColor' : ''"><img src="../assets/house.png" alt @click="handleLevel1Select(3)" /></div>
					<div class="imgTitle" :class="bgColor == 4 ? 'bgColor' : ''"><img src="../assets/traffic.png" alt @click="handleLevel1Select(4)" /></div>
					<div class="imgTitle" :class="bgColor == 5 ? 'bgColor' : ''"><img src="../assets/use.png" alt @click="handleLevel1Select(5)" /></div>
				</div>
				<!-- 二级选择 -->
				<div
					class="container"
					:class="bgColor == 1 ? 'containerImg1' : bgColor == 2 ? 'containerImg2' : bgColor == 3 ? 'containerImg3' : bgColor == 4 ? 'containerImg4' : 'containerImg5'"
				>
					<div class="flex-wrap">
						<div v-for="item in data" :key="item.value" @click="handleLevel2Select(item)">
							<div class="box1" :class="item.show === true ? 'showColor' : ''">{{ item.name }}</div>
						</div>
					</div>
				</div>
				<!-- 计算器 -->
				<div class="calculator">
					<!-- 计算结果 -->
					<div class="calculator1">
						<div v-for="(item, index) in resultList" :key="item.value">
							<div class="resultClase">
								<span style="color: #000; margin-right: 0.3rem; font-weight: bold">{{ item.title }}</span>
								{{ item.name }} {{ item.digit }} {{ item.amount }} 产生：
								<span style="color: #4c81d3">{{ item.result }}</span>
								kg CO
								<span style="font-size: smaller">2e</span>
								<img src="../assets/clear.png" @click="handleReduce(index + 1)" style="height: 1rem; width: 2rem; margin-left: 1rem" />
							</div>
						</div>
					</div>
					<!-- 累计排放 -->
					<div class="calculator2 marginTop" style="height: 3.5rem">
						<div class="flex-between" style="align-items: center; height: 50%">
							<div style="color: #4c81d3; font-weight: bold">累计排放</div>
							<div>
								<span style="color: #4c81d3; margin: 0 0.2rem">{{ total }}</span>
								<span style="color: #909399">
									kg CO
									<span style="font-size: smaller">2e</span>
								</span>
							</div>
						</div>
						<div class="flexBetween" style="align-items: center; height: 50%; font-weight: bold">
							<div>
								累计的碳排放需要
								<span style="color: #42e133; margin: 0 0.2rem">1</span>
								棵树
							</div>
							<div>
								<span style="color: #42e133; margin: 0 0.2rem">{{ lastInfo.tian }}</span>
								天来抵偿
							</div>
						</div>
					</div>
					<!-- 计算过程 -->
					<div class="flex-between marginTop" style="margin-bottom: 1rem; align-items: center">
						<div class="calculator-2">
							<span style="font-size: 2rem; font-weight: 800">{{ dataInfo.title }}</span>
							<div class="triangle"></div>
							<div style="font-size: 0.8rem">{{ dataInfo.name }}</div>
						</div>
						<div class="calculator-2" style="justify-content: space-between; width: 40%">
							<van-field type="number" v-model="digit" class="field" />
							<div style="font-size: 0.8rem; font-weight: bolder">{{ dataInfo.amount }}</div>
						</div>
					</div>
					<!-- 数字计算器 -->
					<div class="flex-between">
						<div class="jiSuan1">
							<div v-for="item in 12" :key="item" @click="handleJiSuan(item)"><img :src="imgMenuTypeCrm_['menuType_' + item]" style="width: 100%" /></div>
						</div>
						<div class="jiSuan2">
							<div
								style="
                color: #4c81d3;
                height: 50%;
                display: flex;
                align-items: center;
              "
								@click="handleTui"
							>
								<img src="../assets/img/icon_del.png" style="width: 100%" />
							</div>
							<div
								style="
                color: #42e133;
                height: 50%;
                display: flex;
                align-items: center;
              "
								@click="handleResult"
							>
								<img src="../assets/img/icon_cal.png" style="width: 100%" />
							</div>
						</div>
					</div>
					<div class="align-Center flex-between" style="margin: 0.5rem 0">
						<img style="width: 48%" src="../assets/grass.png" alt />
						<img src="../assets/img/icon_clear.png" style="width: 48%" @click="handleClear" />
					</div>
					<img src="../assets/boost.png" style="width: 100%" />
				</div>
			</div>
			<img src="../assets/buttom.png" style="width: 100%" />
		</div>

		<!-- PC端 -->
		<div class="pcCon" v-show="fullWidth">
			<div class="pcBanner1">
				<img src="../assets/pc_head3.png" />
			</div>

			<div class="pcBody">
				<div style="width: 66%;margin: 0 17%;">
				<div class="pcBodyLeft">
					<!-- 一级选择 -->
					<div class="flex-between">
						<div class="pcImgTitle" @click="handleLevel1Select(1)" :class="bgColor == 1 ? 'pcBgColor' : ''"><img src="../assets/icon_clothes.png" alt /></div>
						<div class="pcImgTitle" :class="bgColor == 2 ? 'pcBgColor' : ''"><img src="../assets/icon_food.png" alt @click="handleLevel1Select(2)" /></div>
						<div class="pcImgTitle" :class="bgColor == 3 ? 'pcBgColor' : ''"><img src="../assets/icon_house.png" alt @click="handleLevel1Select(3)" /></div>
						<div class="pcImgTitle" :class="bgColor == 4 ? 'pcBgColor' : ''"><img src="../assets/icon_traffic.png" alt @click="handleLevel1Select(4)" /></div>
						<div class="pcImgTitle" :class="bgColor == 5 ? 'pcBgColor' : ''"><img src="../assets/icon_use.png" alt @click="handleLevel1Select(5)" /></div>
					</div>
					<!-- 二级选择 -->
					<div
						class="pcContainer"
						:class="bgColor == 1 ? 'pcContainerImg1' : bgColor == 2 ? 'pcContainerImg2' : bgColor == 3 ? 'pcContainerImg3' : bgColor == 4 ? 'pcContainerImg4' : 'pcContainerImg5'"
					>
						<div class="flex-wrap">
							<div v-for="item in data" :key="item.value" @click="handleLevel2Select(item)">
								<div class="box1" :class="item.show === true ? 'showColor' : ''" style="margin-left:0.5rem;">{{ item.name }}</div>
							</div>
						</div>
					</div>
				</div>

				<div class="pcBodyRight">
					<!-- 计算器 -->
					<div class="calculator">
						<!-- 计算结果 -->
						<div class="calculator1">
							<div v-for="(item, index) in resultList" :key="item.value">
								<div class="resultClase" style="font-size: 0.9rem">
									<span style="color: #000; margin-right: 0.3rem; font-weight: bold">{{ item.title }}</span>
									{{ item.name }} {{ item.digit }} {{ item.amount }} 产生：
									<span style="color: #4c81d3">{{ item.result }}</span>
									kg CO
									<span style="font-size: smaller">2e</span>
									<img src="../assets/clear.png" @click="handleReduce(index + 1)" style="height: 1rem; width: 2rem; margin-left: 1rem" />
								</div>
							</div>
						</div>
						<!-- 累计排放 -->
						<div class="calculator2 marginTop" style="height: 3.5rem">
							<div class="flex-between" style="align-items: center; height: 50%;font-size: 1rem;">
								<div style="color: #4c81d3; font-weight: bold">累计排放</div>
								<div>
									<span style="color: #4c81d3; margin: 0 0.2rem">{{ total }}</span>
									<span style="color: #909399">
										kg CO
										<span style="font-size: smaller">2e</span>
									</span>
								</div>
							</div>
							<div class="flexBetween" style="font-size: 0.9rem;">
								<div>
									累计的碳排放需要
									<span style="color: #42e133; margin: 0 0.2rem">1</span>
									棵树
								</div>
								<div>
									<span style="color: #42e133; margin: 0 0.2rem">{{ lastInfo.tian }}</span>
									天来抵偿
								</div>
							</div>
						</div>
						<!-- 计算过程 -->
						<div class="flex-between marginTop" style="margin-bottom: 1rem; align-items: center">
							<div class="calculator-2">
								<span style="font-size: 2.2rem; font-weight: 800">{{ dataInfo.title }}</span>
								<div class="triangle"></div>
								<div style="font-size: 0.9rem">{{ dataInfo.name }}</div>
							</div>
							<div class="calculator-2" style="justify-content: space-between; width: 40%">
								<van-field type="number" v-model="digit" class="field" />
								<div style="font-size: 0.9rem; font-weight: bolder">{{ dataInfo.amount }}</div>
							</div>
						</div>
						<!-- 数字计算器 -->
						<div class="flex-between">
							<div class="jiSuan1">
								<div v-for="item in 12" :key="item" @click="handleJiSuan(item)"><img :src="imgMenuTypeCrm_['menuType_' + item]" style="width: 100%" /></div>
							</div>
							<div class="jiSuan2">
								<div style=" color: #4c81d3; height: 50%; display: flex; align-items: center; " @click="handleTui" >
									<img src="../assets/img/icon_del.png" style="width: 100%" />
								</div>
								<div style=" color: #42e133; height: 50%; display: flex; align-items: center; " @click="handleResult" >
									<img src="../assets/img/icon_cal.png" style="width: 100%" />
								</div>
							</div>
						</div>
						<div class="align-Center flex-between" style="margin: 0.5rem 0">
							<img style="width: 48%" src="../assets/grass.png" alt />
							<img src="../assets/img/icon_clear.png" style="width: 48%" @click="handleClear" />
						</div>
						<img src="../assets/boost.png" style="width: 100%" />
					</div>
				</div>
				</div>
			</div>

			<div class="pcFooter"><img src="../assets/pc_footer.png" /></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'index',
	data() {
		return {
			fullWidth: true,
			bgColor: 1,
			data: [
				{
					name: '衣服',
					value: '1',
					amount: '件',
					calculation: 6.1,
					title: '衣',
					show: true,
					result: null,
					digit: null
				},
				{
					name: '洗衣粉',
					value: '2',
					amount: '千克',
					calculation: 0.72,
					title: '衣',
					show: false,
					result: null,
					digit: null
				}
			],
			clothesData: [
				{
					name: '衣服',
					value: '1',
					amount: '件',
					calculation: 6.1,
					title: '衣',
					show: true,
					result: null,
					digit: null
				},
				{
					name: '洗衣粉',
					value: '2',
					amount: '千克',
					calculation: 0.72,
					title: '衣',
					show: false,
					result: null,
					digit: null
				}
			],
			foodData: [
				{
					name: '米饭',
					value: '1',
					amount: '千克',
					calculation: 2.7,
					title: '食',
					show: true,
					result: null,
					digit: null
				},
				{
					name: '蛋类',
					value: '2',
					amount: '千克',
					calculation: 4.8,
					title: '食',
					show: false,
					result: null,
					digit: null
				},
				{
					name: '猪肉',
					value: '3',
					amount: '千克',
					calculation: 12.1,
					title: '食',
					show: false,
					result: null,
					digit: null
				},
				{
					name: '牛肉',
					value: '4',
					amount: '千克',
					calculation: 27,
					title: '食',
					show: false,
					result: null,
					digit: null
				},
				{
					name: '羊肉',
					value: '5',
					amount: '千克',
					calculation: 39.2,
					title: '食',
					show: false,
					result: null,
					digit: null
				},
				{
					name: '鱼肉',
					value: '6',
					amount: '千克',
					calculation: 1.4,
					title: '食',
					show: false,
					result: null,
					digit: null
				},
				{
					name: '花生',
					value: '7',
					amount: '千克',
					calculation: 2.5,
					title: '食',
					show: false,
					result: null,
					digit: null
				},
				{
					name: '乳类',
					value: '8',
					amount: '千克',
					calculation: 1.9,
					title: '食',
					show: false,
					result: null,
					digit: null
				},
				{
					name: '吸烟',
					value: '9',
					amount: '包',
					calculation: 0.02,
					title: '食',
					show: false,
					result: null,
					digit: null
				}
			],
			liveData: [
				{
					name: '用水',
					value: '1',
					amount: '立方米',
					calculation: 0.91,
					title: '住',
					show: true,
					result: null,
					digit: null
				},
				{
					name: '用电',
					value: '2',
					amount: '度',
					calculation: 0.5257,
					title: '住',
					show: false,
					result: null,
					digit: null
				},
				{
					name: '天然气',
					value: '3',
					amount: '立方米',
					calculation: 0.2165,
					title: '住',
					show: false,
					result: null,
					digit: null
				},
				{
					name: '煤气',
					value: '4',
					amount: '吨',
					calculation: 0.71,
					title: '住',
					show: false,
					result: null,
					digit: null
				}
			],
			rowData: [
				{
					name: '公交车',
					value: '1',
					amount: '公里',
					calculation: 0.0128,
					title: '行',
					show: true,
					result: null,
					digit: null
				},
				{
					name: '私家车',
					value: '2',
					amount: '公里',
					calculation: 0.239,
					title: '行',
					show: false,
					result: null,
					digit: null
				},
				{
					name: '地铁',
					value: '3',
					amount: '站',
					calculation: 0.1,
					title: '行',
					show: false,
					result: null,
					digit: null
				},
				{
					name: '轮船',
					value: '4',
					amount: '公里',
					calculation: 0.01,
					title: '行',
					show: false,
					result: null,
					digit: null
				},
				{
					name: '飞机',
					value: '5',
					amount: '公里',
					calculation: 0.18243,
					title: '行',
					show: false,
					result: null,
					digit: null
				},
				{
					name: '自行车',
					value: '6',
					amount: '公里',
					calculation: 0,
					title: '行',
					show: false,
					result: null,
					digit: null
				}
			],
			useData: [
				{
					name: '塑料袋',
					value: '1',
					amount: '个',
					calculation: 0.01,
					title: '用',
					show: true,
					result: null,
					digit: null
				},
				{
					name: '纸制品',
					value: '2',
					amount: '千克',
					calculation: 3.5,
					title: '用',
					show: false,
					result: null,
					digit: null
				},
				{
					name: '方便筷',
					value: '5',
					amount: '双',
					calculation: 0.01,
					title: '用',
					show: false,
					result: null,
					digit: null
				}
			],
			dataInfo: {
				name: '衣服',
				value: '1',
				amount: '件',
				calculation: 7,
				title: '衣',
				show: true
			},
			lastInfo: {
				tian: '',
				ke: ''
			},
			imgMenuTypeCrm_: {
				menuType_1: require('../assets/img/icon_1.png'),
				menuType_2: require('../assets/img/icon_2.png'),
				menuType_3: require('../assets/img/icon_3.png'),
				menuType_4: require('../assets/img/icon_4.png'),
				menuType_5: require('../assets/img/icon_5.png'),
				menuType_6: require('../assets/img/icon_6.png'),
				menuType_7: require('../assets/img/icon_7.png'),
				menuType_8: require('../assets/img/icon_8.png'),
				menuType_9: require('../assets/img/icon_9.png'),
				menuType_10: require('../assets/img/icon_0.png'),
				menuType_11: require('../assets/img/icon_00.png'),
				menuType_12: require('../assets/img/icon_dian.png')
			},
			digit: '',
			screenHeight: document.documentElement.clientHeight + 'px',
			result: '',
			resultList: [],
			total: ''
		};
	},
	mounted() {
		// window.onresize = () => {
		//   return (() => {
		//     this.screenHeight = document.documentElement.clientHeight + 'px'
		//   })()
		// }
		//监听屏幕变化
		window.onresize = () => {
			this.page_width();
		};
		this.page_width();
	},
	methods: {
		page_width() {
			//获取屏幕宽度
			let screenWidth = window.screen.width;
			// console.log(screenWidth);
			if (screenWidth < 800) {
				this.fullWidth = false;
			} else {
				this.fullWidth = true;
			}
		},
		// 点击一级
		handleLevel1Select(item) {
			switch (item) {
				case 1:
					this.data = this.clothesData;
					this.bgImg = 'clothes';
					break;
				case 2:
					this.data = this.foodData;
					break;
				case 3:
					this.data = this.liveData;
					break;
				case 4:
					this.data = this.rowData;
					break;
				case 5:
					this.data = this.useData;
					break;
			}
			this.bgColor = item;
			this.dataInfo = {
				name: this.data[0].name,
				value: this.data[0].value,
				amount: this.data[0].amount,
				calculation: this.data[0].calculation,
				title: this.data[0].title,
				show: true
			};
		},
		// 清除一行结果
		handleReduce(item) {
			this.resultList.splice(item - 1, 1);
			this.total = null;
			if (this.resultList.length !== undefined && this.resultList.length > 0) {
				this.resultList.forEach(item => {
					this.total = this.total + Number(item.result);
				});
				this.lastInfo.tian = Number(this.total * 5.415 * 0.0001 * 365).toFixed(1);
				this.total = this.total.toFixed(2);
			}
		},
		// 点击二级
		handleLevel2Select(item) {
			this.data.forEach(item => {
				item.show = false;
			});
			item.show = true;
			this.dataInfo = item;
		},
		// 数字计算器
		handleJiSuan(item) {
			switch (item) {
				case 10:
					item = '0';
					break;
				case 11:
					item = '00';
					break;
				case 12:
					item = '.';
					break;
			}
			if (this.digit == '00' || this.digit == '000') {
				this.digit = 0;
			} else {
				this.digit = this.digit + item;
			}
			// this.digit = this.digit + item
		},
		// 退格
		handleTui() {
			this.digit = this.digit.substr(0, this.digit.length - 1);
		},
		// 计算结果
		handleResult() {
			if (this.digit != 0 && this.digit != '') {
				this.dataInfo.result = Number(this.digit * this.dataInfo.calculation).toFixed(2);
				this.dataInfo.digit = this.digit;
				let info = {
					name: this.dataInfo.name,
					value: this.dataInfo.value,
					amount: this.dataInfo.amount,
					calculation: this.dataInfo.calculation,
					title: this.dataInfo.title,
					show: this.dataInfo.show,
					result: this.dataInfo.result,
					digit: this.dataInfo.digit
				};
				this.resultList.push(info);
				this.total = null;
				this.resultList.forEach(item => {
					this.total = Number(this.total) + Number(item.result);
				});
				this.lastInfo.tian = Number(this.total * 5.415 * 0.0001 * 365).toFixed(1);
				this.total = this.total.toFixed(2);
				this.$nextTick(() => {
					let box = this.$el.querySelector('.calculator1');
					box.scrollTop = box.scrollHeight;
				});
				this.digit = '';
			}
		},
		// 全部清除
		handleClear() {
			this.resultList = [];
			this.total = '';
			this.digit = '';
			this.lastInfo.ke = '';
			this.lastInfo.tian = '';
		}
	}
};
</script>
<style lang="less">
[v-cloak] {
	display: none;
}
.resultClase {
	display: flex;
	color: #606266;
	font-size: 0.8rem;
	align-items: center;
	margin-bottom: 0.3rem;
}
.calculator {
	width: 80%;
	padding: 5%;
	margin: 2rem 5% 1rem 5%;
	border-radius: 20px;
	background-color: #4c81d3;
	min-height: 20rem;
	box-shadow: 0px 0px 3rem #c8d3ee;
	position: relative;
	.calculator1 {
		background-color: #fff;
		border-radius: 10px;
		height: 5rem;
		width: 90%;
		padding: 5%;
		overflow: auto;
		white-space: nowrap;
		//overflow: scroll;
		//overflow-y: scroll;
		box-shadow: 0px 0px 1rem #c8d3ee inset;
	}
	.calculator2 {
		background-color: #fff;
		border-radius: 10px;
		height: 5rem;
		width: 90%;
		padding: 5%;
		overflow: hidden;
		white-space: nowrap;
		//overflow: scroll;
		box-shadow: 0px 0px 1rem #c8d3ee inset;
	}
	.calculator-2 {
		display: flex;
		margin: 0 2%;
		align-items: center;
		color: #fff;
		.field {
			width: 60%;
			border-radius: 10px;
			height: 1.5rem;
			align-content: center;
			box-shadow: 0 0 0.8rem #c8d3ee inset;
			input.van-field_control {
				text-align: right;
			}
		}
		h2 {
			margin: 0;
		}
	}
	.marginTop {
		margin-top: 1rem;
	}
	.triangle {
		margin-left: 10px;
		float: left;
		width: 0;
		height: 0;
		border-width: 5px 10px 5px 10px;
		border-style: solid;
		border-color: transparent #fff transparent transparent;
		transform: rotate(180deg); /*顺时针旋转90°*/
	}
}
.containerImg1 {
	text-align: right;
	background: url('../assets/imgTitle/zi_clothing.png') no-repeat;
	background-size: 7rem 7rem;
	background-position: 102% 130%;
}
.containerImg2 {
	text-align: right;
	background: url('../assets/imgTitle/zi_food.png') no-repeat;
	background-size: 7rem 7rem;
	background-position: 102% 130%;
}
.containerImg3 {
	text-align: right;
	background: url('../assets/imgTitle/zi_house.png') no-repeat;
	background-size: 7rem 7rem;
	background-position: 102% 130%;
}
.containerImg4 {
	text-align: right;
	background: url('../assets/imgTitle/zi_trffic.png') no-repeat;
	background-size: 7rem 7rem;
	background-position: 102% 130%;
}
.containerImg5 {
	text-align: right;
	background: url('../assets/imgTitle/zi_use.png') no-repeat;
	background-size: 7rem 7rem;
	background-position: 102% 130%;
}
.container {
	background-color: #fff;
	margin-top: -0.3rem;
	position: relative;
	z-index: 2;
	min-height: 10rem;
	box-shadow: 0px 0px 1rem #c8d3ee;
	border-radius: 2px 2px 5px 5px;
	.flex-wrap {
		color: #4c81d3;
		padding-top: 0.5rem;
		width: 90%;
		margin-left: 5%;
		div {
			width: 21%;
			text-align: center;
			font-size: 0.8rem;
			margin: 2% 2% 1% 2%;
			div {
				padding: 0.18rem;
				border-radius: 5px;
				border: 1px solid #4c81d3;
				width: 80%;
			}
		}
	}
}
.imgTitle {
	background-color: #fff;
	border-radius: 5px 5px 0 0;
	width: 18%;
	height: 3rem;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0px 0px 1rem #c8d3ee;
	img {
		width: 60%;
		height: 60%;
	}
}
.showColor {
	color: #fff;
	background-color: #4c81d3;
}
.jiSuan1 {
	width: 70%;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	div {
		//background-color: #fff;
		width: 22%;
		// height: 1.6rem;
		margin: 2% 1.5%;
		align-items: center;
		display: flex;
		justify-content: center;
		//color: #4c81d3;
		border-radius: 12px;
		box-shadow: 0px 0px 1rem #40547d;
	}
}
.jiSuan2 {
	width: 30%;
	margin-left: 2%;
	div {
		align-items: center;
		// padding: 0.4rem;
		// background-color: #fff;
		// border-radius: 1rem;
		// text-align: center;
		// font-weight: bold;
		// box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 0 6px rgba(0, 0, 0, 0.4);
	}
}
.title {
	color: #fff;
	font-size: 1.2rem;
	font-weight: bold;
	text-align: center;
}
.van-field__body {
	margin-top: -0.6rem;
}
.flexBetween {
	color: #4c81d3;
	margin-top: 0.3rem;
	font-size: 0.8rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 50%;
	font-weight: bold;
}
.bgColor {
	box-shadow: 0px 0px 0rem #c8d3ee;
	position: relative;
	z-index: 10;
}

.pcCon{
	width: 100%;
	// margin: 0 10%;
	//background-image: url(../assets/beijingtupian.jpg);
}
.pcBanner1 {
	width: 100%;
}
.pcBanner1 img {
	width: 100%;
}
.pcBody {
	background-color: rgba(237, 235, 246, 1);
	// width: 66%;
	height: 900px;
	// margin: 0 17%;
	margin-top:-25rem;
}
.pcBodyLeft {
	width: 50%;
	float: left;
	margin: 24rem 2.5% 0 2.5%;
}

.pcImgTitle {
	background-color: #fff;
	border-radius: 15px 15px 0 0;
	width: 18%;
	height: 4rem;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0px 0px 1rem #c8d3ee;
	img {
		width: 60%;
		height: 70%;
	}
}
.pcBgColor {
	box-shadow: 0px 0px 0rem #c8d3ee;
	position: relative;
	z-index: 10;
}


.pcContainerImg1 {
	text-align: right;
	background: url('../assets/imgTitle/zi_clothing.png') no-repeat;
	background-size: 10rem 10rem;
	background-position: 101% 103%;
}
.pcContainerImg2 {
	text-align: right;
	background: url('../assets/imgTitle/zi_food.png') no-repeat;
	background-size: 10rem 10rem;
	background-position: 101% 103%;
}
.pcContainerImg3 {
	text-align: right;
	background: url('../assets/imgTitle/zi_house.png') no-repeat;
	background-size: 10rem 10rem;
	background-position: 101% 103%;
}
.pcContainerImg4 {
	text-align: right;
	background: url('../assets/imgTitle/zi_trffic.png') no-repeat;
	background-size: 10rem 10rem;
	background-position: 101% 103%;
}
.pcContainerImg5 {
	text-align: right;
	background: url('../assets/imgTitle/zi_use.png') no-repeat;
	background-size: 10rem 10rem;
	background-position: 101% 103%;
}
.pcContainer {
	background-color: #fff;
	margin-top: -0.3rem;
	position: relative;
	z-index: 2;
	min-height: 30.5rem;
	box-shadow: 0px 0px 1rem #c8d3ee;
	border-radius: 7px 7px 15px 15px;
	.flex-wrap {
		color: #4c81d3;
		padding-top: 0.5rem;
		width: 90%;
		margin-left: 5%;
		div {
			width: 21%;
			text-align: center;
			font-size: 1rem;
			margin: 2% 2% 1% 2%;
			div {
				padding: 0.15rem;
				border-radius: 10px;
				border: 2px solid #4c81d3;
				width: 80%;
			}
		}
	}
}

.pcBodyRight {
	width: 42%;
	float: left;
	margin-top: 15rem;
}
.pcFooter img {
	width: 100%;
	margin-top: -4rem;
}
</style>
